import { MoreVerticalIcon } from "lucide-react";
import React from "react";
import { DataManActionButton } from "../../components/DataManActionButton";
import { useDataMan } from "../../hooks/useDataMan";

export const DataManHierarchyRowActions: React.FC = () => {
  const { hierarchyActions, maxActionButtons = 0 } = useDataMan();
  const sanitizedActions = JSON.stringify(hierarchyActions);

  const _actions = React.useMemo(() => {
    if (!hierarchyActions) return [];
    if (hierarchyActions.length <= maxActionButtons) {
      return hierarchyActions.map((action, index) => {
        return <DataManActionButton key={String(index)} action={action} />;
      });
    }

    return (
      <DataManActionButton
        action={{
          id: "more-actions",
          label: "Actions",
          icon: MoreVerticalIcon,
          subs: hierarchyActions
        }}
      />
    );
  }, [sanitizedActions, maxActionButtons]);

  return <div className={"flex items-center gap-2"}>{_actions}</div>;
};
